module.exports = __webpack_public_path__ + "6750a8d55be056833c5d28a7c1b6654d.svg";